module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/high-capacity-transport.9f62dd78.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/high-capacity-transport.png
// module id = 3718
// module chunks = 11